var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg028Keys(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31__px",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.5 11.5c.28 0 .5.22.5.5s-.22.5-.5.5h-.5v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.5 11.5h10.5v1h-10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.5 24h-9.5c.28 0 .5-.22.5-.5v-.5h9c.83 0 1.5-.67 1.5-1.5v-9h.5c.28 0 .5-.22.5-.5v9.5c0 1.38-1.12 2.5-2.5 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 2.5v9.5c0-.28-.22-.5-.5-.5h-.5v-9c0-.83-.67-1.5-1.5-1.5h-9v-.5c0-.28-.22-.5-.5-.5h9.5c1.38 0 2.5 1.12 2.5 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 6c.28 0 .5.22.5.5s-.22.5-.5.5h-4c-.28 0-.5-.22-.5-.5s.22-.5.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 16c.28 0 .5.22.5.5s-.22.5-.5.5h-4c-.28 0-.5-.22-.5-.5s.22-.5.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 19c.28 0 .5.22.5.5s-.22.5-.5.5h-4c-.28 0-.5-.22-.5-.5s.22-.5.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.5 23v.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.5 12.5h1v10.5h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.5 11.5h1v1h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.5 1h1v10.5h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.5.5v.5h-1v-.5c0-.28.22-.5.5-.5s.5.22.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1 11.5h10.5v1h-10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 6c.28 0 .5.22.5.5s-.22.5-.5.5h-1.5v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.85 19.15c.2.19.2.51 0 .7-.09.1-.22.15-.35.15s-.26-.05-.35-.15l-1.15-1.15.7-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.15 16.15c.19-.2.51-.2.7 0 .2.19.2.51 0 .7l-1.15 1.15-.7-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.505 17.505h.99v.99h-.99z",
    transform: "matrix(.707 -.707 .707 .707 -10.971 9.515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.5 7v1.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.5 6h1v1h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.5 4.5v1.5h-1v-1.5c0-.28.22-.5.5-.5s.5.22.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 17.3-.7.7-1.15-1.15c-.2-.19-.2-.51 0-.7.19-.2.51-.2.7 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.5 6v1h-1.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.85 19.85c-.09.1-.22.15-.35.15s-.26-.05-.35-.15c-.2-.19-.2-.51 0-.7l1.15-1.15.7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1 11.5v1h-.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 2.5c0-1.38 1.12-2.5 2.5-2.5h9.5c-.28 0-.5.22-.5.5v.5h-9c-.83 0-1.5.67-1.5 1.5v9h-.5c-.28 0-.5.22-.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1 21.5c0 .83.67 1.5 1.5 1.5h9v.5c0 .28.22.5.5.5h-9.5c-1.38 0-2.5-1.12-2.5-2.5v-9.5c0 .28.22.5.5.5h.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg028Keys);
export default __webpack_public_path__ + "static/media/028-keys.8dadcc2b7188494baf414a8243aa8aca.svg";
export { ForwardRef as ReactComponent };